export const lead = 'text-[17px] md:text-xl text-white leading-relaxed'
export const card = 'rounded-3xl border border-white/10 bg-[#0A1628]'
export const note = 'text-sm text-gray-500'
